module.exports = __webpack_public_path__ + "static/media/task.f0f0369d.svg";